import React from 'react'

import Panel, { PanelLevel } from '@cinch/oxd-components/panel/src'
import SVG from '@cinch/oxd-components/svg/src'
import { Text, TextStyles } from '@cinch-labs/design-system'

import Star from './icons/star.svg'

import * as styles from './payment-info-panel.module.css'

interface PaymentInfoPanelProps {
  title: string
  body: string
  footer: string
  level?: PanelLevel
}

const PaymentInfoPanel: React.FC<PaymentInfoPanelProps> = ({ title, body, footer, level = PanelLevel.low }) => (
  <Panel isPadded={false} isBodyFlex={true} className={styles.panel} level={level}>
    <div className={styles.textContainer}>
      <div className={styles.icon}>
        <SVG children={Star} size={100} />
      </div>
      <div className={styles.textContent}>
        <Text oxford={true} element="h4" type={TextStyles.cardTitle}>
          {title}
        </Text>
        <Text oxford={true} type={TextStyles.body1}>
          {body}
        </Text>
      </div>
    </div>
    <div className={styles.priceContainer}>
      <Text oxford={true} type={TextStyles.cardTitle}>
        {footer}
      </Text>
    </div>
  </Panel>
)

export default PaymentInfoPanel
